/* globals BUILDSTR */

import './js/app.module';

if (BUILDSTR) {
    var element = document.createElement('div');
    element.innerHTML = BUILDSTR;
    element.setAttribute("id", "build-string");
    document.body.appendChild(element);
}



// WEBPACK FOOTER //
// ./src/index.js